import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { getApi } from "../../services/api/globalApi";
import { useNavigate } from "react-router";
import { digitsThree } from "../../utils/price";
import { useSelector } from "react-redux";
import { utilsState } from "../../sotre/redux/features/utilsSlice";
import { couponListColumns } from "../../constant/tablesColumns/tablesColums";
import { convertDate } from "../../utils/convertDate";
import Button from "../../components/common/button/Button";
import { toast } from "react-toastify";
import { PublicFileUrl } from "../../services/config";

export default function CouponList() {
  const [couponData, setCouponData] = useState([]);
  const { utils } = useSelector(utilsState);

  const getCoupon = async () => {
    const path = "admin/coupons";
    try {
      const response = await getApi({ path });
      setCouponData(response?.data?.result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCoupon();
  }, []);

  const navigate = useNavigate();

  const data = [];

  couponData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      expireDate: item?.expireDate ? convertDate(item?.expireDate) : "",
      value: `${digitsThree(item?.value)}` || "",
      status: item.status === "active" ? "فعال" : "غیر فعال",
      type: item?.type === "price" ? "قیمت" : "درصد",
      isLimited: item?.isLimited ? "بله" : "خیر",
      setFreeShipping: item?.setFreeShipping ? "بله" : "خیر",
      minPrice: `${digitsThree(item?.minPrice)}` || "",
      maxPrice: `${digitsThree(item?.maxPrice)}` || "",
      id: item?._id,
      query: item?.forQueryParams.map((items) => {
        return <span>{items} ,</span>;
      }),
    })
  );

  const editCoupon = (singleCoupon) => {
    const newSingleCoupon = couponData.filter((item) => {
      return item._id == singleCoupon.id;
    });
    navigate("/edit-coupon", { state: newSingleCoupon[0] });
  };

  const exportCouponUsage = async (coupon) => {
    if (!coupon?.code) {
      toast.error("کد کوپن یافت نشد");
      return;
    }

    try {
      toast.info("در حال ایجاد فایل اکسل...");
      const path = `admin/coupons/export?couponCode=${coupon.code}`;
      const response = await getApi({ path });

      if (response?.data?.result) {
        const fileName = response.data.result;
        const downloadUrl = `${PublicFileUrl}downloads/${fileName}`;

        window.open(downloadUrl, "_blank");
        toast.success("فایل اکسل با موفقیت ایجاد شد");
      }
    } catch (error) {
      console.log(error);
      toast.error(error?.response?.data?.message || "خطا در ایجاد فایل اکسل");
    }
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <div className="flex justify-between items-center mb-6 gap-4">
        <Title title={"لیست کوپن ها"} />
        <Button
          onClick={() => navigate("/add-coupon")}
          text="افزودن کوپن"
          color="success"
          type="button"
          className="whitespace-nowrap min-w-fit"
        />
      </div>
      <Table
        columns={couponListColumns}
        rows={data}
        onEdit={editCoupon}
        onCustomFunction={exportCouponUsage}
        customFunctionName="خروجی اکسل"
      />
    </div>
  );
}
